<template>
  <div>
    <a-row justify="space-between" align="middle" class="mb-2">
      <a-col :span="8">
        <a-row type="flex" align="middle">
          <svg
            focusable="false"
            data-icon="arrow-left"
            width="1.3em"
            height="2em"
            fill="currentColor"
            aria-hidden="true"
            viewBox="64 64 896 896"
            style="cursor: pointer"
            @click="goBack"
          >
            <path
              d="M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
            ></path>
          </svg>
          <a-typography-title :level="4" class="ml-1" style="margin-bottom: 0">
            Datos colaborador
          </a-typography-title>
        </a-row>
      </a-col>
      <a-col>
        <a-button @click="openEditEmployeeModal">Editar info</a-button>
      </a-col>
    </a-row>
    <a-row class="mb-4">
      <a-col :span="24">
        <div>
          <a-card :body-style="'padding:0;'" :bordered="false">
            <a-descriptions class="" bordered>
              <a-descriptions-item label="RUT" :span="3">
                {{ rutToolBox.formatRut(employeeData?.rut) }}
              </a-descriptions-item>
              <a-descriptions-item label="Nombre completo" :span="3">
                {{ employeeData?.fullname }}
              </a-descriptions-item>
              <a-descriptions-item label="Grupo(s)" :span="3">
                {{ employeeData.groupCompanies?.map((g) => g.name).join(',') }}
              </a-descriptions-item>
              <a-descriptions-item label="Fecha de nacimiento" :span="3">
                {{
                  employeeData.birthdayDate
                    ? moment(employeeData?.birthdayDate, 'YYYY-MM-DD').format(
                        'DD/MM/YYYY'
                      )
                    : 'Sin información'
                }}
              </a-descriptions-item>
              <a-descriptions-item label="Correo" :span="3">
                {{ employeeData?.email }}
              </a-descriptions-item>
              <a-descriptions-item label="Estado" :span="3">
                <a-tag :color="getColorByState(employeeData?.status)">
                  {{ (getTagText(employeeData?.status) ?? '').toUpperCase() }}
                </a-tag>
              </a-descriptions-item>
            </a-descriptions>
          </a-card>
          <a-row v-if="employeeData?.status === 'PENDING'" class="mt-3">
            <a-col :span="24">
              <a-button
                type="primary"
                class="ml-0"
                @click="openPendingTicketsModal"
              >
                Detalle
              </a-button>
              <a-typography-text type="primary" class="ml-2">
                Revisar detalle de tickets pendientes
              </a-typography-text>
            </a-col>
          </a-row>
        </div>
      </a-col>
    </a-row>
    <a-row justify="space-between" align="middle">
      <a-col :span="8">
        <a-space direction="vertical">
          <a-typography-title :level="4">Coberturas</a-typography-title>
        </a-space>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-between" align="middle" class="mb-2">
      <a-col :span="12">
        <a-radio-group :value="typeSelection" @change="handleChange">
          <a-radio-button style="margin: 1px; z-index: 0" value="Vigente">
            Vigente
          </a-radio-button>
          <a-radio-button value="No vigente">No Vigente</a-radio-button>
        </a-radio-group>
      </a-col>
    </a-row>

    <employee-coverage-table
      :data="employeeCoverages"
      :loading="false"
      @edit-dates="openEditCoverageDatesModal"
      @unsubscribe="openUnsubscribeCoverageModal"
      @delete="openDeleteCoverageConfirm"
    />

    <edit-coverage-dates-modal
      ref="editCoverageDatesModalRef"
      @patchedEmployecoverage="fetchCoverageEmployee"
    />
    <unsubscribe-coverage-modal
      ref="unsubscribeCoverageModalRef"
      @patchedEmployecoverage="fetchCoverageEmployee"
    />
    <confirm-action-modal
      :visible="deleteCoverageConfirmVisible"
      :title="deleteCoverageConfirmTitle"
      :message="deleteCoverageConfirmMessage"
      :help-text="deleteCoverageConfirmHelpText"
      :confirm-text="deleteCoverageConfirmButtonText"
      danger
      :loading="deleteCoverageLoading"
      @update:visible="deleteCoverageConfirmVisible = $event"
      @confirm="confirmDeleteCoverage"
      @cancel="deleteCoverageRecord = null"
    />

    <a-row justify="space-between" align="middle" class="mt-3">
      <a-col :span="8">
        <a-space direction="vertical">
          <a-typography-title :level="4">Cargas</a-typography-title>
        </a-space>
      </a-col>
    </a-row>
    <coverage-dependent-table
      :data="dependentGroups"
      :loading="loadingCargasTable"
      @edit-dependent="openEditDependentModal"
      @edit-dates="openEditDependentDatesModal"
      @unsubscribe="openUnsubscribeDependentModal"
      @remove="openRemoveDependentConfirm"
    />

    <edit-dependent-modal
      ref="editDependentModalRef"
      @saved="fetchCoverageEmployee"
    />
    <edit-coverage-dependent-dates-modal
      ref="editDependentDatesModalRef"
      @patchedEmployeeDependent="fetchCoverageEmployee"
    />
    <unsubscribe-coverage-dependent-modal
      ref="unsubscribeDependentModalRef"
      @patchedEmployeeDependent="fetchCoverageEmployee"
    />
    <confirm-action-modal
      :visible="removeDependentConfirmVisible"
      :title="removeDependentConfirmTitle"
      :message="removeDependentConfirmMessage"
      :help-text="removeDependentConfirmHelpText"
      :confirm-text="removeDependentConfirmButtonText"
      danger
      :loading="removeDependentLoading"
      @update:visible="removeDependentConfirmVisible = $event"
      @confirm="confirmRemoveDependent"
      @cancel="removeDependentRecord = null"
    />
    <a-modal
      v-model:visible="showPendingTicketsModal"
      title="Tickets pendientes del colaborador"
      :footer="null"
      centered
      destroyOnClose
      width="650px"
    >
      <a-descriptions size="small" :column="1" class="mb-3 no-bg-descriptions">
        <a-descriptions-item label="Titular">
          {{ employeeData?.fullname }}
        </a-descriptions-item>
        <a-descriptions-item label="RUT">
          {{ rutToolBox.formatRut(employeeData?.rut) }}
        </a-descriptions-item>
      </a-descriptions>

      <a-table
        row-key="id"
        size="small"
        :columns="pendingTicketsColumns"
        :data-source="pendingTickets"
        :pagination="false"
        :scroll="{ y: 280 }"
      >
        <template #state="{ text }">
          <tags v-if="text" :stateId="text" />
          <span v-else>-</span>
        </template>

        <template #action="{ record }">
          <a
            :href="getTicketHref(record.raw)"
            class="ant-btn ant-btn-link ant-btn-sm"
            @click="($event) => goToTicket(record.raw, $event)"
          >
            Ver más
          </a>
        </template>
      </a-table>

      <div style="text-align: right; margin-top: 16px">
        <a-button @click="showPendingTicketsModal = false">Cerrar</a-button>
      </div>
    </a-modal>
    <edit-employee-info-modal
      ref="editEmployeeInfoModalRef"
      @saved="refreshEmployeeData"
    />
  </div>
</template>

<script>
import { computed, onBeforeMount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import {
  FETCH_EMPLOYEE,
  GET_FULL_NAME,
  FETCH_USER_BY_COMPANY,
  GET_USER_BY_COMPANY,
  GET_COVERAGE_EMPLOYEE,
  FETCH_COVERAGE_EMPLOYEE,
  GET_EMPLOYEE,
  FETCH_COMPANY_EMPLOYEE_DEPENDENTS,
  DELETE_EMPLOYEE_COVERAGE,
  DELETE_EMPLOYEE_LOAD
} from '@/store/types';
import getTagColor from '@/utils/getTagColor';
import rutToolBox from '@/utils/Ruts';
import EditEmployeeInfoModal from '@/components/clients/stock/modal-edit-employee-info.vue';
import EmployeeCoverageTable from '@/components/clients/stock/employee-coverage-table.vue';
import EditCoverageDatesModal from '@/components/clients/stock/edit-coverage-dates-modal.vue';
import UnsubscribeCoverageModal from '@/components/clients/stock/unsubscribe-coverage-modal.vue';
import ConfirmActionModal from '@/bewell-components/modals/confirm-action-modal.vue';
import EditDependentModal from '@/components/clients/stock/edit-dependent-modal.vue';
import CoverageDependentTable from '@/components/clients/stock/coverage-dependent-table.vue';
import EditCoverageDependentDatesModal from '@/components/clients/stock/edit-coverage-dependent-dates-modal.vue';
import UnsubscribeCoverageDependentModal from '@/components/clients/stock/unsubscribe-coverage-dependent-modal.vue';
import getTagText from '@/utils/getTagText';
import notification from '@/utils/notifications';
import {
  toStockDependentGroups,
  flattenStockDependentGroups
} from '@/utils/stockDependentGroups';
import moment from 'moment';
import { useRouter } from 'vue-router';
import Tags from '@/components/tags.vue';

export default {
  name: 'ProfileCollaborator',
  emit: ['Poliza'],
  components: {
    'edit-employee-info-modal': EditEmployeeInfoModal,
    'employee-coverage-table': EmployeeCoverageTable,
    'edit-coverage-dates-modal': EditCoverageDatesModal,
    'unsubscribe-coverage-modal': UnsubscribeCoverageModal,
    'confirm-action-modal': ConfirmActionModal,
    'edit-dependent-modal': EditDependentModal,
    'coverage-dependent-table': CoverageDependentTable,
    'edit-coverage-dependent-dates-modal': EditCoverageDependentDatesModal,
    'unsubscribe-coverage-dependent-modal': UnsubscribeCoverageDependentModal,
    tags: Tags
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const typeSelection = ref('');
    const { id, colaborador } = route.params;

    const router = useRouter();
    const editEmployeeInfoModalRef = ref();
    const editCoverageDatesModalRef = ref();
    const unsubscribeCoverageModalRef = ref();
    const deleteCoverageRecord = ref(null);
    const deleteCoverageConfirmVisible = ref(false);
    const deleteCoverageLoading = ref(false);
    const editDependentModalRef = ref();
    const editDependentDatesModalRef = ref();
    const unsubscribeDependentModalRef = ref();
    const removeDependentRecord = ref(null);
    const removeDependentConfirmVisible = ref(false);
    const removeDependentLoading = ref(false);

    const getTicketRoute = (ticket) => {
      const routeByType = {
        1: 'AltasDetalle',
        2: 'BajaDetail',
        3: 'DetalleModificaciones',
        4: 'TransferDetail',
        5: 'AltaCargasDetalle',
        6: 'BajaCargasDetalle'
      };

      const name = routeByType[ticket?.typeId];

      if (!name) {
        return null;
      }

      return {
        name,
        params: { id: ticket.id }
      };
    };

    const getTicketHref = (ticket) => {
      const ticketRoute = getTicketRoute(ticket);
      return ticketRoute ? router.resolve(ticketRoute).href : '#';
    };

    const goToTicket = (ticket, event) => {
      if (
        event?.defaultPrevented ||
        event?.button === 1 ||
        event?.metaKey ||
        event?.ctrlKey ||
        event?.shiftKey ||
        event?.altKey
      ) {
        return;
      }

      event?.preventDefault();

      const ticketRoute = getTicketRoute(ticket);

      if (!ticketRoute) {
        console.warn('No hay ruta para este typeId:', ticket?.typeId, ticket);
        return;
      }

      router.push(ticketRoute);
    };

    const employee = computed(() => store.getters[GET_EMPLOYEE]);

    const employeeData = computed(() => store.getters[GET_USER_BY_COMPANY]);
    const ticketTypeMap = {
      1: 'Alta',
      2: 'Baja',
      3: 'Modificacion',
      4: 'Traspaso',
      5: 'Altas de cargas',
      6: 'Baja de cargas'
    };

    const getTicketTypeName = (typeId) => {
      return ticketTypeMap[typeId] ?? 'Desconocido';
    };
    const getLastTicketState = (ticket) => {
      if (!ticket?.states?.length) return null;

      return [...ticket.states]
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
        .at(-1);
    };

    const belongsToCurrentCompany = (ticket) => {
      const currentCompanyId = String(id ?? '');

      const ticketCompanyIds = [
        ticket?.company?.id,
        ticket?.companyId,
        ticket?.company_id,
        ...(Array.isArray(ticket?.groupCompanies)
          ? ticket.groupCompanies.map((groupCompany) => groupCompany?.id)
          : [])
      ]
        .filter((value) => value !== undefined && value !== null)
        .map((value) => String(value));

      return ticketCompanyIds.includes(currentCompanyId);
    };

    const isTicketPending = (ticket) => {
      const lastState = getLastTicketState(ticket);
      return lastState && lastState.stateId !== 3 && lastState.stateId !== 4;
    };

    const pendingTickets = computed(() => {
      return (employee.value?.tickets ?? [])
        .filter(belongsToCurrentCompany)
        .filter(isTicketPending)
        .map((ticket) => {
          const lastState = getLastTicketState(ticket);
          return {
            id: ticket.id,
            type: getTicketTypeName(ticket.typeId),
            stateId: lastState?.stateId,
            raw: ticket
          };
        });
    });

    const deleteCoverageConfirmTitle = ref('');
    const deleteCoverageConfirmMessage = ref('');
    const deleteCoverageConfirmHelpText = ref('');
    const deleteCoverageConfirmButtonText = ref('');
    const removeDependentConfirmTitle = ref('');
    const removeDependentConfirmMessage = ref('');
    const removeDependentConfirmHelpText = ref('');
    const removeDependentConfirmButtonText = ref('');

    const showPendingTicketsModal = ref(false);
    const dependentGroups = ref([]);
    const cargasByCoverage = computed(() =>
      flattenStockDependentGroups(dependentGroups.value)
    );
    const loadingCargasTable = ref(false);

    const openPendingTicketsModal = (event) => {
      event?.target?.blur();
      showPendingTicketsModal.value = true;
    };

    const pendingTicketsColumns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        customRender: ({ text }) => `#${text}`
      },
      {
        title: 'Tipo',
        dataIndex: 'type',
        key: 'type'
      },
      {
        title: 'Estado',
        dataIndex: 'stateId',
        key: 'stateId',
        slots: { customRender: 'state' }
      },
      {
        title: 'Acción',
        key: 'action',
        slots: { customRender: 'action' }
      }
    ];

    const relationshipLabels = {
      SPOUSE: 'Cónyuge',
      COHABITANT: 'Conviviente',
      CHILD: 'Hijo(a)',
      PARENT: 'Padre/Madre',
      GRANDCHILD: 'Nieto(a)',
      SIBLING: 'Hermano(a)',
      OTHER: 'Otro'
    };

    const getRelationshipLabel = (value) => {
      if (!value) return '-';
      return relationshipLabels[value] || value;
    };

    const formatDate = (dateValue) => {
      if (!dateValue) return '-';
      return moment(dateValue).format('DD-MM-YYYY');
    };

    const buildVigencia = (startDate, endDate) => {
      const startDateText = formatDate(startDate);
      const endDateText = endDate
        ? formatDate(endDate)
        : 'Sin fecha de término';
      return `${startDateText} / ${endDateText}`;
    };
    const name = computed(() => store.getters[GET_FULL_NAME]);
    const employeeCoverages = computed(
      () => store.getters[GET_COVERAGE_EMPLOYEE]
    );
    const dependentOptionsForAssociation = computed(() => {
      const seen = new Set();
      return (cargasByCoverage.value || []).reduce((acc, row) => {
        if (!row?.dependentId || seen.has(row.dependentId)) return acc;
        seen.add(row.dependentId);
        acc.push({
          id: row.dependentId,
          rut: row.rut,
          fullName: row.fullName,
          relationship: row.relationship
        });
        return acc;
      }, []);
    });
    const coverageOptionsForAssociation = computed(() =>
      (employeeCoverages.value || [])
        .filter((coverage) => coverage?.status === 'ACTIVE')
        .map((coverage) => ({
          employeeCoverageId: coverage?.employeeCoverageId,
          policyNumber: coverage?.policy?.numberPolicy || '-',
          groupName: coverage?.groupCompany?.name || '-',
          name: coverage?.name || '-'
        }))
    );
    const canAddDependentAssociation = computed(
      () =>
        dependentOptionsForAssociation.value.length > 0 &&
        coverageOptionsForAssociation.value.length > 0
    );
    const addAssociationDisabledReason = computed(() => {
      if (canAddDependentAssociation.value) return '';
      if (!dependentOptionsForAssociation.value.length) {
        return 'No hay cargas existentes para asociar.';
      }
      if (!coverageOptionsForAssociation.value.length) {
        return 'No hay coberturas vigentes disponibles para asociar.';
      }
      return 'No es posible crear la asociación por el momento.';
    });

    // * Colores por estado
    const getColorByState = (value) => {
      return getTagColor(value);
    };

    const handleChange = async (val) => {
      typeSelection.value = val.target.value;
      if (
        typeSelection.value == 'Vigente' &&
        employeeCoverages.value.filter((f) => f.status == 'ACTIVE')
      ) {
        employeeCoverages.value.filter((f) => f.status == 'ACTIVE');
        await store.dispatch(FETCH_COVERAGE_EMPLOYEE, {
          companyId: id,
          employeeId: colaborador,
          queryParam: '?status=ACTIVE'
        });
        await fetchDependentCoverageRows();
      } else if (
        typeSelection.value == 'No vigente' &&
        employeeCoverages.value.filter((f) => f.status == 'INACTIVE')
      ) {
        employeeCoverages.value.filter((f) => f.status == 'INACTIVE');
        await store.dispatch(FETCH_COVERAGE_EMPLOYEE, {
          companyId: id,
          employeeId: colaborador,
          queryParam: '?status=INACTIVE'
        });
        await fetchDependentCoverageRows('INACTIVE');
      }
    };

    const fetchCoverageEmployee = async () => {
      try {
        await store.dispatch(FETCH_COVERAGE_EMPLOYEE, {
          companyId: id,
          employeeId: colaborador,
          queryParam: '?status=ACTIVE'
        });
        await fetchDependentCoverageRows();
      } catch (err) {
        notification('error', 'Error', err?.response?.data?.message);
      }
    };

    // Dependents grouped by dependent come from a single request. The status
    // filter applies to the employee coverages, as the coverages table above.
    const fetchDependentCoverageRows = async (coverageStatus = 'ACTIVE') => {
      loadingCargasTable.value = true;
      try {
        const groups = await store.dispatch(FETCH_COMPANY_EMPLOYEE_DEPENDENTS, {
          companyId: id,
          employeeId: colaborador,
          coverageStatus
        });
        dependentGroups.value = toStockDependentGroups(groups || [], {
          employeeId: colaborador,
          formatRut: rutToolBox.formatRut,
          formatDate,
          getRelationshipLabel,
          buildValidity: buildVigencia
        });
      } catch (error) {
        dependentGroups.value = [];
        notification(
          'error',
          'Error al cargar cargas',
          error?.response?.data?.message || 'No se pudieron cargar las cargas.'
        );
      } finally {
        loadingCargasTable.value = false;
      }
    };

    const refreshEmployeeData = async () => {
      await store.dispatch(FETCH_EMPLOYEE, route.params.colaborador);
      await store.dispatch(FETCH_USER_BY_COMPANY, {
        company_id: route.params.id,
        employee_id: route.params.colaborador
      });
    };

    const openEditEmployeeModal = () => {
      editEmployeeInfoModalRef.value?.openModal(employeeData.value);
    };

    const openEditCoverageDatesModal = (record) => {
      editCoverageDatesModalRef.value?.openModal(record);
    };

    const openUnsubscribeCoverageModal = (record) => {
      unsubscribeCoverageModalRef.value?.openModal(record);
    };

    const openDeleteCoverageConfirm = (record) => {
      deleteCoverageRecord.value = record;
      deleteCoverageConfirmTitle.value = 'Eliminar cobertura';
      deleteCoverageConfirmMessage.value = `¿Estás seguro que deseas eliminar la cobertura ${record?.name || ''}?`;
      deleteCoverageConfirmHelpText.value =
        'Las coberturas que ya han sido parte de un proceso de validación y cuadratura de nómina dentro del periodo no podrán ser eliminadas.';
      deleteCoverageConfirmButtonText.value = 'Sí, eliminar';
      deleteCoverageConfirmVisible.value = true;
    };

    const confirmDeleteCoverage = async () => {
      deleteCoverageLoading.value = true;
      try {
        await store.dispatch(
          DELETE_EMPLOYEE_COVERAGE,
          deleteCoverageRecord.value.id
        );
        notification(
          'success',
          'Correcto',
          'Cobertura eliminada correctamente.'
        );
        deleteCoverageConfirmVisible.value = false;
        deleteCoverageRecord.value = null;
        await fetchCoverageEmployee();
      } catch (error) {
        notification('error', 'Error', error?.response?.data?.message);
      }
      deleteCoverageLoading.value = false;
    };

    const openEditDependentModal = (record) => {
      editDependentModalRef.value?.openModal(record);
    };

    const openEditDependentDatesModal = (record) => {
      editDependentDatesModalRef.value?.openModal(record);
    };

    const openUnsubscribeDependentModal = (record) => {
      unsubscribeDependentModalRef.value?.openModal(record);
    };

    const openRemoveDependentConfirm = (record) => {
      removeDependentRecord.value = record;
      removeDependentConfirmTitle.value = 'Quitar asociación carga-cobertura';
      removeDependentConfirmMessage.value = `¿Estás seguro que deseas quitar la asociación ${record?.fullName || record?.rut || ''} de la cobertura ${record?.coverageName || ''}?`;
      removeDependentConfirmHelpText.value =
        'Esta acción elimina solo la asociación de la carga con esta cobertura. La carga seguirá existiendo para otras coberturas activas.';
      removeDependentConfirmButtonText.value = 'Sí, quitar';
      removeDependentConfirmVisible.value = true;
    };

    const confirmRemoveDependent = async () => {
      removeDependentLoading.value = true;
      try {
        await store.dispatch(DELETE_EMPLOYEE_LOAD, {
          employeeCoverageId: removeDependentRecord.value.employeeCoverageId,
          employeeCoverageDependentId:
            removeDependentRecord.value.employeeCoverageDependentId
        });
        notification(
          'success',
          'Correcto',
          'Asociación carga-cobertura eliminada correctamente.'
        );
        removeDependentConfirmVisible.value = false;
        removeDependentRecord.value = null;
        await fetchCoverageEmployee();
      } catch (error) {
        notification('error', 'Error', error?.response?.data?.message);
      }
      removeDependentLoading.value = false;
    };

    const goBack = () => {
      router.go(-1);
    };

    onBeforeMount(async () => {
      await refreshEmployeeData();
    });

    onMounted(async () => {
      await fetchCoverageEmployee();
      typeSelection.value = 'Vigente';
    });

    return {
      // current_tab,
      loadingCargasTable,
      getColorByState,
      cargasByCoverage,
      dependentGroups,
      name,
      employeeCoverages,
      employeeData,
      rutToolBox,
      getTagText,
      typeSelection,
      handleChange,
      fetchCoverageEmployee,
      fetchDependentCoverageRows,
      canAddDependentAssociation,
      addAssociationDisabledReason,
      showPendingTicketsModal,
      openPendingTicketsModal,
      pendingTickets,
      pendingTicketsColumns,
      getLastTicketState,
      getTicketTypeName,
      getTicketHref,
      goToTicket,
      employee,
      editEmployeeInfoModalRef,
      editCoverageDatesModalRef,
      unsubscribeCoverageModalRef,
      deleteCoverageConfirmVisible,
      deleteCoverageConfirmTitle,
      deleteCoverageConfirmMessage,
      deleteCoverageConfirmHelpText,
      deleteCoverageConfirmButtonText,
      deleteCoverageLoading,
      deleteCoverageRecord,
      openEditCoverageDatesModal,
      openUnsubscribeCoverageModal,
      openDeleteCoverageConfirm,
      confirmDeleteCoverage,
      editDependentModalRef,
      editDependentDatesModalRef,
      unsubscribeDependentModalRef,
      removeDependentRecord,
      removeDependentConfirmVisible,
      removeDependentLoading,
      removeDependentConfirmTitle,
      removeDependentConfirmMessage,
      removeDependentConfirmHelpText,
      removeDependentConfirmButtonText,
      openEditDependentModal,
      openEditDependentDatesModal,
      openUnsubscribeDependentModal,
      openRemoveDependentConfirm,
      confirmRemoveDependent,
      openEditEmployeeModal,
      goBack,
      refreshEmployeeData,
      moment
    };
  }
};
</script>

<style>
.no-bg-descriptions .ant-descriptions-item-label,
.no-bg-descriptions .ant-descriptions-item-content {
  background: transparent !important;
}
</style>
